<template>
    <div v-if="isProcessing" class="activating-subscription-container mt-10">
        <v-progress-circular indeterminate color="var(--primary)" size="50" width="5"></v-progress-circular>
        <span class="onboarding-text">Activating your subscription</span>
    </div>

    <v-card-text v-else class="narrow-container">
        <span class="onboarding-title d-block text-center mb-12">Let's get started</span>

        <span v-if="form.plan_id == 1" class="onboarding-text text-center d-block mb-5">Free forever. Enjoy.</span>
        <span v-if="form.plan_id > 1" class="onboarding-text text-center d-block mb-5">
                <template v-if="form.plan_id == 3">
                    Pro yearly plan starts at ${{ (getProductPrice(selectedPlan.slug) - getProductDiscount(selectedPlan.slug)) / 12 }}/month billed annually. The total charge for your first year of service
                    is ${{ (getProductPrice(selectedPlan.slug) - getProductDiscount(selectedPlan.slug)) }}.
                </template>
                <template v-if="form.plan_id == 5">
                    Team yearly plan starts at ${{ (getProductPrice(selectedPlan.slug) - getProductDiscount(selectedPlan.slug)) / 12 }}/month billed annually. The total charge for your first year of service
                    is ${{ (getProductPrice(selectedPlan.slug) - getProductDiscount(selectedPlan.slug)) }}.
                </template>

                <span class="text-decoration-underline">Cancel anytime</span>
                .
            </span>

        <v-btn v-if="selectedPlan && selectedPlan.id == 1" color="primary" large depressed block rounded @click="onSubmit" class="mb-10">
            Create my free account
        </v-btn>

        <div v-else class="d-flex flex-column align-center">
            <TermsOfSaleAgreementCheckbox @change="termsOfSale = $event" />

            <v-btn :disabled="!termsOfSale && !user.terms_of_sale_agreement" color="primary" large depressed block rounded @click="onSubmit" class="mb-10">
                Start my subscription
            </v-btn>
        </div>

        <v-select
            v-model="form.plan_id"
            :items="selectablePlans"
            item-text="name"
            item-value="id"
            :error-messages="form.$errors.plan_id"
            :menu-props="{ offsetY: true }"
            placeholder="Select a different trial plan"
            outlined
            @blur="form.validate('plan_id')"
            @input="delete form.$errors.plan_id"
        />
    </v-card-text>
</template>

<script>
import { mapGetters, mapState, mapActions } from "vuex";
import TermsOfSaleAgreementCheckbox from "@/components/app/ui/TermsOfSaleAgreementCheckbox.vue";

export default {
    components: {TermsOfSaleAgreementCheckbox},
    async created() {
        this.$root.onboardingGetStarted = this;

        await this.$store.dispatch('Plans/fetchPlans');
        await this.$store.dispatch("Products/fetchAllPrices");

        this.form.plan_id = this.selectablePlans.find(plan => plan.id == this.account.plan_id).id;

        // If user refreshed the app while the webhook is being waited for, check if the subscription was activated in the meantime
        this.fetchCurrentPlanInterval = setInterval(async () => {
            if (this.account.plan_id == this.PLAN_FREE.id) return;

            await this.$store.dispatch("User/fetchCurrentPlan");
            if (this.$route.name !== 'onboarding.get-started' || this.isProcessing) {
                clearInterval(this.fetchCurrentPlanInterval);
                return;
            }

            await this.$store.dispatch('User/fetchUser');

            if (this.currentPlan?.fastspring.active && this.account.onboarding == 'get_started') {
                clearInterval(this.fetchCurrentPlanInterval);
                this.$router.push({ name: "onboarding.organization" });
            }
        }, 3000);
    },

    data() {
        return {
            termsOfSale: false,
            isProcessing: false,
            fetchCurrentPlanInterval: null,

            form: new Form(this, "form", {
                plan_id: null,
            }),
        };
    },

    computed: {
        ...mapState("User", ["account", "currentPlan"]),
        ...mapGetters("User", ["user"]),
        ...mapGetters('Plans', ['getSelectablePlansWhenRegistering']),
        ...mapGetters('Products', ['getProductPrice', 'getProductDiscount']),
        ...mapState('Plans', ['PLAN_FREE']),

        selectablePlans() {
            if (this.user.accounts.filter(account => account.role_id == 2).length > 1) {
                return this.getSelectablePlansWhenRegistering.filter(plan => plan.slug !== 'free');
            }

            return this.getSelectablePlansWhenRegistering;
        },

        selectedPlan() {
            return this.selectablePlans.find(plan => plan.id == this.form.plan_id);
        },

        accountOwnerNumber() {
            return this.user.accounts.filter(account => account.role_id == 2).length;
        },
    },

    methods: {
        ...mapActions("User", ["fetchUser"]),

        async onSubmit() {
            if (this.account.plan_id !== this.selectedPlan.id) {
                await this.$store.dispatch("Organizations/changePlan", this.form.plan_id);
            }

            // FREE PLAN
            if (this.selectedPlan.id == 1) {
                await this.fetchUser();
                this.$router.push({
                    name: "onboarding.organization",
                });
            }

            // PAID PLAN
            else {
                const fcsBtn = document.querySelector("#fcs-btn");

                let planSlug = this.selectedPlan.slug;
                if (this.accountOwnerNumber > 1) planSlug += "-no-trial";

                fastspring.builder.tag({
                    action: 'PURCHASE_SUBSCRIPTION',
                    account_id: this.account.id,
                    environment: process.env.NODE_ENV
                });

                fastspring.builder.recognize({
                    email: this.user.email,
                });

                if (localStorage.getItem('selected_product')) {
                    fastspring.builder.add(localStorage.getItem('selected_product'))
                }

                fcsBtn.setAttribute("data-popup-closed", "onFSPopupClosed");
                fcsBtn.setAttribute("data-fsc-item-path-value", planSlug);
                fcsBtn.click();
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.activating-subscription-container {
    display: flex;
    flex-direction: column;
    align-items: center;

    > span {
        margin-top: 15px;
    }
}
</style>
